import { Controller } from 'stimulus'

export default class extends Controller {
  static get targets() {
    return ['input', 'characterCount', 'clearButton', 'liveRegion']
  }

  initialize() {
    if (this.hasInputTarget) {
      $(this.inputTarget).on('clear', this.clear.bind(this))

      if (this.inputTarget.value.length > 0) {
        this.showClearButton()
      }
    }
  }

  /**
     * Show the "clear" button
     */
  showClearButton() {
    if (!this.hasClearButtonTarget) {
      return
    }

    this.clearButtonTarget.removeAttribute('hidden')
  }

  /**
     * Hide the "clear" button
     */
  hideClearButton() {
    if (!this.hasClearButtonTarget) {
      return
    }

    this.clearButtonTarget.setAttribute('hidden', 'hidden')
  }

  /**
     * Determine whether or not to show the "clear" button
     * @param {KeyboardEvent} event
     */
  toggleClearButton(event) {
    if (event.target.value.length > 0) {
      this.showClearButton()
    } else {
      this.hideClearButton()
    }
  }

  /**
     * Clear the value from the input
     */
  clear() {
    this.inputTarget.value = ''
    this.inputTarget.dispatchEvent(new CustomEvent('input'))

    this.hideClearButton()

    if (this.hasCharacterCountTarget) {
      this.updateCharactersRemainingCount()
    }

    $(this.inputTarget).focus()
  }

  /**
     *
     */
  updateCharactersRemainingCount() {
    const valueLength = $(this.inputTarget).val().length
    const valueMaximum = $(this.inputTarget).data('characterLimit')
    const charactersRemaining = valueMaximum - valueLength
    $(this.characterCountTarget).text(charactersRemaining)
  }

  /**
     * Validate the value in the input
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/Constraint_validation}
     * {@link https://stimulus.hotwire.dev/reference/controllers#properties}
     */
  validate() {
    const validity = $(this.inputTarget)[0].validity
    if (validity.valid === false) {
      $(this.element).addClass('is-invalid')
    } else {
      $(this.element).removeClass('is-invalid')
    }
  }
}
